import * as Backbone from "backbone";
import * as $ from "jquery";
import * as _ from "lodash";
import { BaseInternalView, BaseInternalViewOptions } from "../_BaseViews";
import { AddInstallModal } from "../modals/AddInstallModal";
import { AddOrganizationModal } from "../modals/AddOrganizationModal";
import { GenericDeleteModal } from "../modals/GenericDeleteModal";

export interface EditOrganizationsOptions extends BaseInternalViewOptions {}

export class EditOrganizationsView extends BaseInternalView {
    private template = _.template(require("templates/admin/editOrganizations.html"));
    private orgId: number;

    constructor(options: EditOrganizationsOptions) {
        super(
            <any>_.extend(
                {
                    events: {
                        "click .add-organization-modal-trigger": "handleAddOrganizationClick",
                        "click .associate-install-modal-organization": "handleAssociateInstall",
                        "click .delete-organization-modal-organization": "handleOrganizationDelete",
                    },
                },
                options
            )
        );
    }

    render() {
        this.$el.html(
            this.template({
                organizationCollection: this.options.organizationCollection,
            })
        );

        return this;
    }

    show() {
        this.render();
    }

    private handleAddOrganizationClick(e) {
        const existingRow = $(e.currentTarget).parents(".table__row");
        let org;
        let orgId;

        // if there is a row it means it's an Edit, else an Add
        if (existingRow) {
            const orgId = Number(existingRow.attr("data-org-id"));
            if (orgId) {
                org = this.options.organizationCollection.findWhere({ id: orgId });
            }
        }

        const view = new AddOrganizationModal(
            _.extend({}, this.options, {
                appCollection: this.options.appCollection,
                org: org,
                modelId: orgId,
            })
        );
        $(".modals").append(view.render().el);
        view.show();
    }

    private handleAssociateInstall(e) {
        const existingRow = $(e.currentTarget).parents(".table__row");
        let org;
        let orgId;

        // if there is a row it means it's an Edit, else an Add
        if (existingRow) {
            const orgId = Number(existingRow.attr("data-org-id"));
            if (orgId) {
                org = this.options.organizationCollection.findWhere({ id: orgId });
            }
        }

        const view = new AddInstallModal(
            _.extend({}, this.options, {
                org: org,
                modelId: orgId,
            })
        );
        $(".modals").append(view.render().el);
        view.show();
    }

    private handleOrganizationDelete(e) {
        const self = this;

        const row = $(e.currentTarget).parents(".table__row");

        const orgId = Number(row.attr("data-org-id"));
        const orgName = String(row.attr("data-org-name"));
        let org;
        if (orgId) {
            org = this.options.organizationCollection.findWhere({ id: orgId });
        }
        var modal = new GenericDeleteModal({
            type: "Organization",
            name: orgName,
            func: () => {
                const result = org.destroy();
                if (typeof result === "boolean") {
                    return;
                }
                const xhr = <JQueryXHR>result;
                xhr.done(() => {
                    self.refetchCollectionsAndShow();
                    modal.hide();
                });
            },
        });
        $(".modals").append(modal.render().el);
        modal.show();
    }

    private refetchCollectionsAndShow() {
        var d1 = this.options.installCollection.fetch({ reset: true });
        var d2 = this.options.permissionCollection.fetch({ reset: true });
        var d3 = this.options.organizationCollection.fetch({ reset: true });
        var d4 = this.options.appCollection.fetch({ reset: true });

        $.when(d1, d2, d3, d4)
            .done(() => {
                Backbone.history.loadUrl();
                window['App'].Bus.trigger('navigation:update');
            })
            .fail(() => {
                console.log("ERROR"); // TODO!
            });
    }

    remove() {
        // while (this.subViews.length) this.subViews.pop().remove();
        // But also do what the super view would normally do
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/admin/EditOrganizationsView.ts